const NS = 'WoolLabSwatchDetailModalBlock';
const CLS = 'woolLabSwatchDetailModalBlock';

import * as THREE from 'three';
import CameraControls from 'camera-controls';
import 'magnify';
import Handlebars from 'handlebars';
import {WoolLabSaveToMoodboardModalBlock} from './woolLabSaveToMoodboardModalBlock';
import { handleTruncate } from '../../helpers/truncate';

export class WoolLabSwatchDetailModalBlock {

	constructor(el, data = {}) {

		this.$el = $(el);
		this.data = data;
		this.getSwatchDetailApi = data.getSwatchDetailApi;
		this.getSupplierDetailApi = data.getSupplierDetailApi;
		this.isInMySwatchesApi = data.isInMySwatchesApi;

		this.username = this.$el.data('username');
		this.isStudentApi = data.isStudent;
		this.$btnClose = this.$el.find(`.${CLS}-canvasContainer-btn-close`);
		this.$swatchToggleBtns = this.$el.find(`.${CLS}-swatch-button`);
		this.$arrowBtns = this.$el.find(`.${CLS}-arrow`);
		this.$btnPrev = this.$el.find(`.${CLS}-arrow.prev`);
		this.$btnNext = this.$el.find(`.${CLS}-arrow.next`);
		this.$widthMarker = this.$el.find(`.${CLS}-widthMarker`);

		this.$canvasContainerInner = this.$el.find(`.${CLS}-canvasContainer-inner`);
		this.$btnSave = this.$el.find(`.${CLS}-detailContainer-btnSave`);
		this.$btnMoodboard = this.$el.find(`.${CLS}-detailContainer-btnMoodboard`);
		this.$btnGetSupplier = this.$el.find(`.${CLS}-detailContainer-btnSupplier`);

		this.$detailTitle = this.$el.find(`.${CLS}-detailContainer-title`);
		this.$detailID = this.$el.find(`.${CLS}-detailContainer-id`);
		this.$detailWidthCount = this.$el.find(`.${CLS}-widthMarker-count`);
		this.$detailIcons = this.$el.find(`.${CLS}-detailContainer-icons`);
		this.$detailInformation = this.$el.find(`.${CLS}-detailContainer-information`);
		this.$supplierTxt = this.$el.find(`.${CLS}-detailContainer-txtSupplier`);

		this.addToMoodboardApi = data.addToMoodboardApi;
		this.createMoodboardApi = data.createMoodboardApi;
		this.getMoodboardsApi = data.getMoodboardsApi;

		this.$nextSwatch = '';
		this.$prevSwatch = '';

		this.init();
		this.addMoodboardSwatchState();
	}

	init() {
		CameraControls.install( {THREE: THREE} );
		const This = this;
		let $wg = $(this.$el);

		const clock = new THREE.Clock();
		const loader = new THREE.TextureLoader();

		let renderer = new THREE.WebGLRenderer({ antialias: true });
		let scene = new THREE.Scene();
		let cameraControls;
		let camera;
		let swatchMesh;

		var SWATCH_HEIGHT = 7;
		var SWATCH_WIDTH = 7;

		if(this.$el.hasClass( "portrait" )){
			SWATCH_WIDTH = 7 / this.$el.data( "ratio" );
		}
		if(this.$el.hasClass( "landscape" )){
			SWATCH_HEIGHT = 7 / this.$el.data( "ratio" );

		}

		const SWATCH_SIZE = 7;
		const SWATCH_DEPTH = 0.2;
		const DESKTOP_CAMERA_Y = 0;
		const DESKTOP_CAMERA_Z = 20;
		const CAMERA_TRANSITION_X = 15;

		let $zoom;
		let zoomImgURL;

		handleButtons();

		createScene();
        createSwatch();
        createShadow();

		animate();

		cameraControls.moveTo( CAMERA_TRANSITION_X, 0, 0, false );
		cameraControls.rotateAzimuthTo( 0, false );

		showLoadingScreen();
		disableDragging();
		// updateSwatch(This.data);
		// updateDetails(This.data);
		getSwatch(This.data.id);


		const CANVAS_RESIZE_OBSERVER = new ResizeObserver(function(entries) {
			let rect = entries[0].contentRect;
			let width = rect.width;
			let height = rect.height;

			camera.aspect = width / height;
			renderer.setSize(width, height);
			camera.updateProjectionMatrix();
			render();
		});
		CANVAS_RESIZE_OBSERVER.observe(document.querySelector(`.${CLS}-canvasContainer-inner`));


		function createScene() {

			renderer.setClearColor(0xffffff);
			renderer.setPixelRatio(window.devicePixelRatio);
			renderer.setSize(640, 640);
			This.$el.find(`.${CLS}-threejsContent`).append(renderer.domElement);

			// Camera
			camera = new THREE.PerspectiveCamera(35, 1, 1, 1000);
			camera.position.set(0, DESKTOP_CAMERA_Y, DESKTOP_CAMERA_Z);
			scene.add(camera);


			// Orbital Controls
			cameraControls = new CameraControls( camera, renderer.domElement );
			cameraControls.rotateSpeed = 1;
			cameraControls.mouseButtons.right = CameraControls.ACTION.NONE;
			cameraControls.mouseButtons.wheel = CameraControls.ACTION.NONE;
			cameraControls.mouseButtons.middle = CameraControls.ACTION.NONE;
			cameraControls.enableDamping = true;
			cameraControls.dampingFactor = 0.1;
			// limits rotation on the x-axis
			cameraControls.minPolarAngle = Math.PI/2;
			cameraControls.maxPolarAngle = Math.PI/2;


			scene.add(new THREE.AmbientLight(0x666666));
			let light = new THREE.PointLight(0xffffff, 0.65);
			camera.add(light);
		}

		function createSwatch() {
			let swatchGeometry = new THREE.BoxGeometry(SWATCH_WIDTH, SWATCH_HEIGHT, SWATCH_DEPTH);
			let loadingMaterial = new THREE.MeshBasicMaterial({ color: 0xdddddd });
			swatchMesh = new THREE.Mesh(swatchGeometry, loadingMaterial);

			scene.add(swatchMesh);
		}

		function createShadow() {
			const shadowTexture = loader.load('https://threejs.org/manual/examples/resources/images/roundshadow.png');
			const shadowGeo = new THREE.PlaneGeometry(8, 4);
			const shadowMat = new THREE.MeshBasicMaterial({
				map: shadowTexture,
				transparent: true,
				opacity: 0.25,
			});

			let shadowMesh = new THREE.Mesh(shadowGeo, shadowMat);

			shadowMesh.rotation.x = Math.PI * -.5;
			shadowMesh.position.set(0, -4.49, 0);
			scene.add(shadowMesh);
		}

		function animate() {

			const delta = clock.getDelta();
			const updated = cameraControls.update( delta );

			requestAnimationFrame(animate);

			// only render when camera is moving
			if ( updated ) {
				render();
			}
		}

		function render() {
			renderer.render(scene, camera);
		}

		function resetToggles() {
			This.$widthMarker.removeClass('active');
			This.$swatchToggleBtns.removeClass('selected');

			enableDragging();

			if ($zoom) {
				$zoom.destroy();
			}
		}

		function enableDragging() {
			if (This.data.backImageSrc){
				cameraControls.enabled = true;
				This.$canvasContainerInner.addClass('canDrag');
			}
		}
		function disableDragging() {
			cameraControls.enabled = false;
			This.$canvasContainerInner.removeClass('canDrag');
		}

		async function transitionOut() {
			return cameraControls.truck(  CAMERA_TRANSITION_X,  0, true);
		}

		function showLoadingScreen() {
			$wg.addClass('loading');
		}

		function updateDetails(data) {

			This.$detailTitle.html(data.name);
			This.$detailID.html(data.id);
			This.$detailWidthCount.html(data.thickness + "mm");

			updateSavedSwatchState();

			let $swatchLibrary = $('.woolLabSwatchLibrarySearchBlock-swatches');
			let $librarySwatchBlock = $swatchLibrary.find(`[data-id="${data.id}"]`).parent();
			This.$prevSwatchID = $librarySwatchBlock.prev().find('.woolLabSwatchBlock').attr('data-id');
			This.$nextSwatchID = $librarySwatchBlock.next().find('.woolLabSwatchBlock').attr('data-id');

			This.$btnPrev.prop("disabled", !This.$prevSwatchID ? !0 : 0);
			This.$btnNext.prop("disabled", !This.$nextSwatchID ? !0 : 0);

			if (!This.$prevSwatchID && !This.$nextSwatchID){
				This.$btnPrev.hide();
				This.$btnNext.hide();
			}
			else {
				This.$btnPrev.show();
				This.$btnNext.show();
			}

			let iconsHTML = "";
			data.benefits.map(icon => {
				let oriIcon = icon;
				icon = icon.replace('& ',"");
				icon = icon.replace('%',"");
				icon = icon.replaceAll(',',"");
				icon = icon.replace('e/R',"eR");
				icon = icon.replace(/ /g,"_");
				iconsHTML += `<div class="${CLS}-detailContainer-icon iconTooltip"><p><img src="/globalassets/swatches/benefits/${icon}.png"></p><span class="iconTooltiptext">${oriIcon}</span></div>`;
			});
			This.$detailIcons.empty();
			This.$detailIcons.html(iconsHTML);

			let infoHTML = "";
			data.details.map(i => {
				infoHTML += `<div class="${CLS}-detailContainer-information-item">
								<h4 class="${CLS}-detailContainer-information-label">${i.name}</h4>
								<p class="${CLS}-detailContainer-information-measurement">${i.value}</p>
							</div>`;
			});
			if(This.isStudent === false){
				if( data.archived === false){
					if (data.supplierInfo){
						This.$supplierTxt.hide();
						data.supplierInfo.map(i => {
							infoHTML += `<div class="${CLS}-detailContainer-information-item">
											<h4 class="${CLS}-detailContainer-information-label">${i.name}</h4>
											<p class="${CLS}-detailContainer-information-measurement">${i.value}</p>
										</div>`;
						});
					}
					else {
						This.$supplierTxt.show();
						infoHTML += `<div class="${CLS}-detailContainer-information-item">
											<h4 class="${CLS}-detailContainer-information-label">supplier</h4>
											<p class="${CLS}-detailContainer-information-measurement">******</p>
										</div>
										<div class="${CLS}-detailContainer-information-item">
											<h4 class="${CLS}-detailContainer-information-label">supplier contact</h4>
											<p class="${CLS}-detailContainer-information-measurement">******</p>
										</div>
										<div class="${CLS}-detailContainer-information-item">
											<h4 class="${CLS}-detailContainer-information-label">supplier email</h4>
											<p class="${CLS}-detailContainer-information-measurement">******</p>
										</div>`;
					}
				}
			}
			if(data.highlights)
			{
				infoHTML += `<div class="${CLS}-detailContainer-highlights">
								<h4 class="${CLS}-detailContainer-information-label">highlights</h4>
								<p class="${CLS}-detailContainer-information-measurement">${data.highlights}</p>
							</div>`;
			}


			This.$detailInformation.empty();
			This.$detailInformation.html(infoHTML);

			let $highlightInfo = This.$detailInformation.find(`.${CLS}-detailContainer-highlights > p`);
			handleTruncate($highlightInfo, 110);
		}

		function updateSavedSwatchState(){
			This.$btnSave.html(This.data.saved ? 'Saved' :'My Swatches');
			This.$btnSave.prop("disabled", This.data.saved ? !0 : 0);
		}

		function updateSwatch(data) {
			if (data.frontImageSrc) {
				updateSwatchObject({
					frontImgURL: data.frontImageSrc,
					backImgURL: data.backImageSrc ? data.backImageSrc : null,
					sideImgURL: data.sideImageSrc ? data.sideImageSrc : null
				});
			}
			if (!data.backImageSrc){
				$(`.${CLS}-swatch-button-rotate`).hide()
			}
			else {
				$(`.${CLS}-swatch-button-rotate`).show()
			}
			if (!data.thickness){
				$(`.${CLS}-swatch-button-thickness`).hide()
			}
			else {
				$(`.${CLS}-swatch-button-thickness`).show()
			}

		}

		async function updateSwatchObject({ frontImgURL, backImgURL, sideImgURL }) {
			if (frontImgURL) {
				zoomImgURL = frontImgURL;

				loadTexture({
					frontImg: frontImgURL,
					backImg: backImgURL ? backImgURL : null,
					sideImg: sideImgURL ? sideImgURL : null
				}).then(res => onTextureLoaded(res))
				.then( () => {
					cameraControls.moveTo( CAMERA_TRANSITION_X, 0, 0, false );
					cameraControls.rotateAzimuthTo( 0, false );
					cameraControls.reset( true );
					$wg.removeClass('loading');
					enableDragging();
				})
				.catch(res => {});
			}
		}

		function loadTexture({frontImg, backImg, sideImg}) {
			const textures = Promise.all([
				loader.loadAsync(frontImg),
				backImg ? loader.loadAsync(backImg) : null,
				sideImg ? loader.loadAsync(sideImg) : null]
			);

			return textures;
		}

		function onTextureLoaded(textures) {

			let frontTexture = textures[0];
			let backTexture = textures[1] !== null ? textures[1] :frontTexture.clone();
			let sideTexture = textures[2] !== null ? textures[2] :frontTexture.clone();


			let frontMaterial = new THREE.MeshLambertMaterial({
				map: frontTexture, transparent: true, alphaTest: 0.3
			});

			let backMaterial = new THREE.MeshLambertMaterial({
				map: backTexture, transparent: true, alphaTest: 0.3
			});
			backMaterial.map.needsUpdate = true;
			backTexture.wrapS = THREE.RepeatWrapping;
			backTexture.wrapT = THREE.RepeatWrapping;
			backTexture.repeat.set(-1, 1);


			let sideMaterial = new THREE.MeshLambertMaterial({
				map: sideTexture, transparent: true, alphaTest: 0.3
			});
			sideMaterial.map.needsUpdate = true;
			sideTexture.wrapS = THREE.RepeatWrapping;
			sideTexture.wrapT = THREE.RepeatWrapping;
			sideTexture.repeat.set(-SWATCH_WIDTH / SWATCH_SIZE, 1);


			swatchMesh.material =
				[
					sideMaterial, // +x
					sideMaterial, // -x
					frontMaterial, // +y
					frontMaterial, // -y
					frontMaterial, // +z
					backMaterial // -z
				];
		}

		function getSwatch(id) {
			showLoadingScreen();

			// We want to get swatch detail first then supplier info, this ensures that when updateDetails, we have the info to fill the details
			fetch(`${This.getSwatchDetailApi}?swatchId=${id}`, {
				method: 'GET',
			}).then((response) => {
				return response.json();
			}).then((_json) => {
				This.data.highlights = null;
				This.data = {
					...This.data,
					..._json
				};
				This.data.supplierInfo = null;
				return fetch(`${This.getSupplierDetailApi}?swatchId=${id}`, {
					method: 'GET',
				});
			}).then((response) => {
				return response.json();
			}).then((_json) => {
				This.data = {
					...This.data,
					..._json
				};
			}).catch((_error) => {
			}).finally(() => {
				if (This.data){
					updateDetails(This.data);
					updateSwatch(This.data);
				}
			});

			fetch(`${This.isInMySwatchesApi}?swatchId=${id}`, {
				method: 'GET',
			}).then((response) => {
				return response.json();
			}).then((_json) => {
				This.data.saved = _json;
				updateSavedSwatchState();
			}).catch((_error) => { });

			fetch(`${This.isStudentApi}`, {
				method: 'GET',
			}).then((response) => {
				return response.json();
			}).then((_json) => {
				This.isStudent = _json;
			}).catch((_error) => { });
		};

		function saveSwatch() {
			showLoadingScreen();

			let url = `${This.data.addToMySwatchesApi}`;
			fetch(url, {
				cache: 'no-cache',
				body: JSON.stringify([This.data.id]),
				headers: {
					'Content-Type': 'application/json'
				},
				method: 'POST',
			}).then(() => {
				This.data.saved = true;
				return fetch(`${This.getSupplierDetailApi}?swatchId=${This.data.id}`, {
					method: 'GET',
				});
			}).then((response) => {
				return response.json();
			}).then((_json) => {
				This.data = {
					...This.data,
					..._json
				};
			}).catch((_error) => {
				console.log(_error);
			}).finally(() => {
				updateDetails(This.data);
				$wg.removeClass('loading');

				// Global function to refresh MySwatches in Swatch Library
				if (window.awiGlobalHelper && window.awiGlobalHelper.reloadSwatchLibraryMySwatches) {
					window.awiGlobalHelper.reloadSwatchLibraryMySwatches();
				}
			});
		}

		function handleButtons() {

			This.$arrowBtns.on('click', (e) => {
			    transitionOut();
			    resetToggles();
			    disableDragging();

			    if ($(e.currentTarget).hasClass('prev')) {
					if (This.$prevSwatchID) {
						getSwatch(This.$prevSwatchID);
					}
				} else {
					if(This.$nextSwatchID) {
						getSwatch(This.$nextSwatchID);
					}
			    }
			});

			This.$btnClose.on('click', () => {
				CANVAS_RESIZE_OBSERVER.unobserve(document.querySelector(`.${CLS}-canvasContainer-inner`));
			    resetToggles();
			});

			This.$btnSave.on('click', () => {
				saveSwatch();
			});

			This.$btnGetSupplier.on('click', () => {
				getSupplierInfo();
			});

			This.$swatchToggleBtns.on('click', (e) => {

				let $btn = $(e.currentTarget);
				let isSelected = $btn.hasClass('selected');

				cameraControls.reset( true );
				resetToggles();

				if (!isSelected) {

					disableDragging();
					$btn.addClass('selected');
					requestAnimationFrame(animate);

					if ($btn.hasClass(`${CLS}-swatch-button-thickness`)) {
						cameraControls.rotateAzimuthTo( 83 * THREE.MathUtils.DEG2RAD, true );
						This.$widthMarker.addClass('active');
					} else if ($btn.hasClass(`${CLS}-swatch-button-rotate`)) {
						cameraControls.rotateAzimuthTo( 180 * THREE.MathUtils.DEG2RAD, true );
					} else {
						cameraControls.rotateAzimuthTo( 0, true );

						// add zoom effect
						if (zoomImgURL) {
						    $zoom = $(`.${CLS}-zoom`).magnify({
								src: zoomImgURL,
								magnifiedWidth: 1024,
								magnifiedHeight: 1024,
						    });
						}
					}
				}
			});
		}
	}
	addMoodboardSwatchState(){
		this.$btnMoodboard.on('click', () => {
			this.displaySaveToMoodboardModal();
		});
	}

	getSaveToMoodboardModalTemplate() {
        let modalWidget = require('../../partials/widgets/woolLabSaveToMoodboardModalBlock.hbs');

		Handlebars.registerPartial('woolLabSaveToMoodboardModalBlock', modalWidget);

		let template = `
			{{> woolLabSaveToMoodboardModalBlock
				wg="woolLabSaveToMoodboardModalBlock"
				ns="WoolLabSaveToMoodboardModalBlock"
			}}
		`;

		let precompiled = new Function('return ' + Handlebars.precompile(template))();
		return Handlebars.template(precompiled);
	}

	displaySaveToMoodboardModal() {
		$(document.body).append(this.getSaveToMoodboardModalTemplate()(this.data));
		let $modal = $('#woolLabSaveToMoodboardModalBlock');

		let modalData = {};
		modalData.getMoodboardsApi = this.getMoodboardsApi;
		modalData.addToMoodboardApi = this.addToMoodboardApi;
		modalData.createMoodboardApi = this.createMoodboardApi;
		modalData.selectedItems = [this.data.id];
		modalData.itemType ='swatch';

		new WoolLabSaveToMoodboardModalBlock($modal[0], modalData);

		$modal.modal('show');
		$('body').css('padding-right', '0');
		$modal.css('padding', '0');

		$modal.on('shown.bs.modal', () => {
			// need to manually add "in" class so backdrop can display properly due to IDS override
			$('.modal-backdrop').addClass('in');
		});

		$modal.on('hidden.bs.modal', () => {
			$modal.remove();
			$('body').css('padding-right', '');
		});
	}
}
